<template>
  <div>
    <nav-bar/>
    <div class="container pt-4">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="card">
            <div class="card-header">
              <h3 class="my-2">{{$t('Settings.modifyInfo.title')}}</h3>
            </div>
            <div class="card-block">
              <div class="row">
                <regular-input
                :disabled="!isAdmin" 
                :value="user.name"
                @input="user.name = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.companyName') + '*'" class="col-12 col-md-6 form-group"/>
                <regular-input
                :disabled="!isAdmin" 
                :value="user.address"
                @input="user.address = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.address') + '*'" class="col-12 col-md-6 form-group"/>
              </div>
              <div class="row">
                <regular-input
                :disabled="!isAdmin" 
                :value="user.city"
                @input="user.city = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.city') + '*'" class="col-12 col-md-6 form-group"/>
                <regular-input
                :disabled="!isAdmin" 
                :value="user.postcode"
                @input="user.postcode = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.zipCode') + '*'" class="col-12 col-md-6 form-group"/>
              </div>
              <div class="row">
                <regular-select
                :disabled="!isAdmin" 
                :value="user.province"
                @change="user.province = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.province') + '*'" class="col-12 col-md-6 form-group">
                <option v-for="province in provinces">{{province}}</option>
              </regular-select>
              <regular-input
              :disabled="!isAdmin" 
              :value="user.phone"
              @input="user.phone = $event"
              type="text" :placeholder="$t('Settings.modifyInfo.phone') + '*'" class="col-12 col-md-6 form-group"/>
            </div>
            <div class="row">
              <regular-input
              :disabled="!isAdmin" 
              :value="user.nir"
              @input="user.nir = $event"
              type="text" :placeholder="$t('Settings.modifyInfo.NIR') + '*'" class="col-12 col-md-6 form-group"/>
              <regular-input
              :disabled="!isAdmin" 
              :value="user.tps"
              @input="user.tps = $event"
              type="text" :placeholder="$t('Settings.modifyInfo.GST')" class="col-12 col-md-6 form-group"/>
            </div>
            <div class="row">
              <regular-input
              :disabled="!isAdmin" 
              :value="user.tvq"
              @input="user.tvq = $event"
              type="text" :placeholder="$t('Settings.modifyInfo.QST')" class="col-12 col-md-6 form-group"/>
              <regular-input
              :disabled="!isAdmin" 
              :value="user.cigle"
              @input="user.cigle = $event"
              type="text" :placeholder="$t('Settings.modifyInfo.cigle') + '*'" class="col-12 col-md-6 form-group"/>
            </div>
            <div class="row">
              <regular-input
              :disabled="!isAdmin" 
              :value="user.fax"
              @input="user.fax = $event"
              type="text" :placeholder="$t('Settings.modifyInfo.fax')" class="col-12 col-md-6 form-group"/>
              <regular-input
              :disabled="!isAdmin" 
              :value="user.email"
              @input="user.email = $event"
              type="text" :placeholder="$t('Settings.modifyInfo.email')" class="col-12 col-md-6 form-group"/>
              <regular-input-file
              :disabled="!isAdmin"
              name="logo"
              @input="user.logo = $event"
              :placeholder="$t('Settings.modifyInfo.logo')" class="col-12 col-md-6 form-group"/>
            </div>
            <img id='logo' :src="user.logo" class="m-1 img-fluid mini">
            <div class="row">
              <regular-checkbox
              :checked="user.driverComment"
              @change="user.driverComment = $event"
              :label="$t('Settings.modifyInfo.driverComment')" class="col-12"/>
              <div class="col-12">
                <button class="btn btn-kne-orange w-100" :disabled="!modifyFormFilled || !isAdmin" @click="submitInfo()">{{$t('Settings.modifyInfo.submit')}}</button>
              </div>
            </div>
            <div class="mt-3">
              <small>* {{$t('Settings.modifyInfo.disclaimer')}}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6" id="changePass">
        <div class="card">
          <div class="card-header">
            <h3 class="my-2">{{$t('Settings.modifyPass.title')}}</h3>
          </div>
          <div class="card-block">
            <div class="row">
              <regular-input 
              :value="changePass.email"
              @input="changePass.email = $event"
              type="text" :placeholder="$t('Settings.modifyPass.email') + '*'" class="col-12 form-group"/>
              <regular-input 
              :value="changePass.oldPass"
              @input="changePass.oldPass = $event"
              type="password" :placeholder="$t('Settings.modifyPass.oldPass') + '*'" class="col-12 form-group"/>
              <regular-input 
              :value="changePass.newPass"
              @input="changePass.newPass = $event"
              type="password" :placeholder="$t('Settings.modifyPass.newPass') + '*'" class="col-12 form-group"/>
              <regular-input 
              :value="changePass.newPassConfirm"
              @input="changePass.newPassConfirm = $event"
              type="password" :placeholder="$t('Settings.modifyPass.confirmPass') + '*'" class="col-12 form-group"/>
              <div class="col-12">
                <button class="btn btn-kne-orange w-100" :disabled="!modifyPasswordFormFilled || !passwordConfirmation" @click="submitPass()">{{$t('Settings.modifyPass.submit')}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-header">
            <h3 class="my-2">{{$t('Settings.modifyLang.title')}}</h3>
          </div>
          <div class="card-block">
            <div class="row">
              <div class="col-6">
                <input type="button" class="w-100 btn" :class="{'btn-kne-darkgrey' : $store.state.i18n.locale === 'fr', 'btn-kne-orange' : $store.state.i18n.locale === 'en'}" @click="changeLang('en')" value="EN">
              </div>
              <div class="col-6">
                <input type="button" class="w-100 btn" :class="{'btn-kne-darkgrey' : $store.state.i18n.locale === 'en', 'btn-kne-orange' : $store.state.i18n.locale === 'fr'}" @click="changeLang('fr')" value="FR">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import regularInput from '../regularInput.vue'
  import regularSelect from '../regularSelect.vue'
  import regularCheckbox from '../regularCheckbox.vue'
  import regularInputFile from '../regularInputFile.vue'
  import {db} from '../../firebase'
  import Firebase from 'firebase'

  export default {
    name: 'Settings',
    components: {
      regularSelect,
      regularInput,
      regularInputFile,
      regularCheckbox
    },
    data () {
      return {
        provinces: ['BC', 'ON', 'NL', 'NS', 'PE', 'NB', 'QC', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT'],
        user: {
          name: '',
          address: '',
          city: '',
          zipCode: '',
          province: '',
          phone: '',
          nir: '',
          cigle: '',
          logo: ''
        },
        changePass: {
          email: '',
          oldPass: '',
          newPass: '',
          newPassConfirm: ''
        }
      }
    },
    mounted () {
      db.ref('users/transporters').child(this.companyUID).once('value').then((snapshot) => {
        this.$store.commit('setUserInfo', snapshot.val() || false)
        this.user = snapshot.val()
      })
    },
    methods: {
      submitInfo: function () {
        db.ref('users/transporters').child(this.companyUID).update(this.user).then(() => {
          this.$store.commit('setUserInfo', this.user)
          // ======================== ADD COMPANY MODIFICATION LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'COMPANY_MODIFY_INFO', 'date': Date.now()})
          // ======================== ADD COMPANY MODIFICATION LOG =======================
        })
      },
      submitPass: function () {
        var user = Firebase.auth().currentUser
        var credential = Firebase.auth.EmailAuthProvider.credential(
          this.changePass.email,
          this.changePass.oldPass
          )
        console.log(credential)
        user.reauthenticateWithCredential(credential).then(() => {
          user.updatePassword(this.changePass.newPass).then(() => {
            for (var attr in this.changePass) {
              this.changePass[attr] = ''
            }
            console.log('changed password')
          }).catch(function (error) {
            console.log(error)
          })
        }).catch(function (error) {
          console.log(error)
        })
      },
      changeLang: function (lang) {
        db.ref('users/transporters').child(this.companyUID).child('language').set(lang).then(() => {
          this.$store.commit('setUserLang', lang)
          this.$i18n.set(lang)
        })
      }
    },
    computed: {
      modifyFormFilled: function () {
        return this.user.name !== '' && this.user.address !== '' && this.user.city !== '' && this.user.zipCode !== '' && this.user.province !== '' && this.user.phone !== '' && this.user.NIR !== '' && this.user.cigle !== ''
      },
      modifyPasswordFormFilled: function () {
        return this.changePass.newPass !== '' && this.changePass.newPassConfirm !== ''
      },
      passwordConfirmation: function () {
        if (this.changePass.newPass === '') return false
        else if (this.changePass.newPass === this.changePass.newPassConfirm) return true
        else return false
      },
      companyUID () {
        return this.$store.state.authorization.company
      },
      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      },
      uid () {
        return this.$store.state.user.uid
      }
    }
  }
  </script>

  <style scoped>
  .card-header{
    border-bottom: 3px solid #f7941e;
  }
  @media (max-width: 991px) {
    #changePass{
      margin-top: 1rem;
    }
  }
  .btn-kne-darkgrey{
    background-color: #2c2d2f !important;
    border-color: #2c2d2f !important;
    color: rgba(255,255,255,.5) !important;
    cursor: pointer;
  }
  .btn-kne-darkgrey:hover{
    color: rgba(255,255,255,.75) !important;
  }
  #logo{
    height: 10rem;
  }
</style>



// WEBPACK FOOTER //
// Settings.vue?324798cc